import React from 'react'
import {ThemeContext} from '../../theme/DarkMode';
import Markdown from 'react-markdown'
import { useTranslation } from 'react-i18next';

const persianMarkdown = `# سیاست نامه حریم خصوصی
**تاریخ اجرا: ۱ بهمن ۱۴۰۲**

«آهیل» به حریم خصوصی کاربران خود احترام می‌گذارد و متعهد به حفاظت از اطلاعات شخصی است که شما در اختیار آن می‌گذارید. از آنجا که جمع‌آوری و پردازش اطلاعات شخصی بخش غیرقابل اجتنابی در فرایندهای مبتنی بر گوشی همراه و اینترنت است لذا به منظور آگاهی کامل از سیاست و عملکرد آهیل در این زمینه، مطالعه این سند تحت عنوان «سیاست نامه حریم خصوصی» و هر گونه پیام دیگری که در خصوص جمع‌آوری و پردازش اطلاعات توسط آهیل به حساب کاربری شما ارسال می‌شود، ضروری است.

این سند مشتمل بر موارد ذیل است.

۱- درباره آهیل

۲- تغییرات این سند

۳- برنامه، سایت و سرویس‌های اشخاص ثالث

۴- کدام اطلاعات توسط آهیل جمع‌آوری می‌شوند

۵- آهیل از اطلاعات چه استفاده‌ای می کند

۶- اطلاعات در اختیار چه اشخاصی قرار می‌گیرند

۷- امنیت اطلاعات شخصی

۸- درخواست‌های شما

۹- شرایط درخواست

## ۱. درباره آهیل
آهیل اولین پلتفرم هوشمند برنامه ریزی بر پایه شبکه اجتماعی می‌باشد که کاربران میتوانند در آن اقدام به ارائه، فروش و همینطور خرید برنامه، آموزش و محصول کنند.

در این سند، منظور از «آهیل» و «ما»، شرکت رهپویان آرمان نگرش نوین اکسون با شماره ثبت ۲۰۹۱۸ است.

## ۲. تغییرات این سند 
این سند مطابق با آخرین تغییرات قوانین و مقررات موضوعه کشور تدوین شده و مبیّن کلیه حقوق شما تحت قانون تجارت الکترونیکی مصوب ۱۳۸۲و اسناد بین‌المللی ذی‌ربط است.

این سند ممکن است دستخوش تغییرات و تجدیدنظر شود و در صورتی که اطلاع‌رسانی تغییرات به موجب قانون الزامی باشد، این تغییرات به کاربران اطلاع داده خواهد شد. این سند، آخرین بار در تاریخ ۱ بهمن ۱۴۰۲ مورد بازبینی و به‌روزرسانی قرار گرفت.

## ۳- برنامه، سایت و خدمات اشخاص ثالث
نرم‌افزار آهیل حاوی لینک‌های متعلق به اشخاص ثالث است به نحوی که کلیک کردن روی آن‌ها می‌تواند منجر به جمع‌آوری اطلاعات شخصی شما شود. توصیه آهیل این است که علاوه بر این سند و تغییرات آن، سیاست‌های حریم خصوصی (Privacy Policy) لینک‌های متعلق به اشخاص ثالث را به دقت مطالعه کنید. آهیل هیچ مسئولیتی در قبال اطلاعاتی که با اشخاص ثالث به اشتراک می‌گذارید نخواهد داشت. این امر در مورد مطالب اشخاص ثالث که در سایت مشاهده می‌کنید و پیشنهادهایی که در رابطه با استفاده از محصولات و خدمات خود دارند، نیز صادق است.

## ۴- کدام اطلاعات توسط آهیل جمع آوری می شوند
اطلاعات ممکن است با نصب و یا استفاده شما از خدمات آهیل (اطلاعات فنی و گزارش‌های سرور عمدتاً به این شیوه جمع‌آوری می‌شوند و در سرورهای ما نگهداری می‌شوند) در دسترس و اختیار آهیل قرار گیرد، همچنین آهیل ممکن است اطلاعات را مستقیماً از شما دریافت کند (هنگام ایجاد حساب کاربری، تماس و مکاتبه با پشتیبانی و یا تکمیل هر فرم یا ورود اختیاری اطلاعات).

۱-۴- اطلاعاتی که با نصب و یا استفاده از نرم‌افزار آهیل جمع‌آوری می‌شوند

اطلاعات مربوط به استفاده از خدمات آهیل و اطلاعات دستگاهی که نرم‌افزار آهیل بر روی آن نصب شده‌ است همزمان با نصب نرم‌افزار بر روی دستگاه شما (بدون ایجاد حساب کاربری) جمع‌آوری می‌شوند. برخی از  این اطلاعات عبارتند از: 

۱-۱-۴- نوع دستگاه، نوع سیستم عامل دستگاه شما، 

۲-۱-۴- شناسه اندروید و شناسه تبلیغاتی اندروید ویژه دستگاه شما،

> شناسه تبلیغاتی اندروید صرفاً به منظور تحلیل رفتار کاربر و نمایش تبلیغات یا پیشنهادات به صورت شخصی‌سازی‌شده، بدون اینکه به‌طور مستقیم به شخص حقیقی معین و مشخص مرتبط باشد، مورد استفاده قرار می‌گیرد. در صورت تغییر شناسه تبلیغاتی توسط کاربر، شناسه تبلیغاتی جدید به شناسه تبلیغاتی قبلی و اطلاعات مرتبط به آن، متصل نخواهد شد.

۳-۱-۴- جست‌وجوهای انجام شده و نتایج انتخاب‌شده، 

۴-۱-۴- اطلاعات فنی و اطلاعات مهم دستگاه هنگام وقفه‌ها (Crashes) شامل میزان کل رم و میزان فضای پر آن هنگام وقفه, نوع وقفه، 

۵-۱-۴- ما ممکن است از کوکی‌ها (cookies) در جمع‌آوری اطلاعات استفاده کنیم. کوکی فایلی است که به درخواست یک سایت، توسط مرورگر ایجاد می‌شود و به سایت امکان ذخیره بازدید‌های شما و مناسب‌سازی آنها را فراهم می‌نماید. به عنوان مثال ما با استفاده از کوکی می‌توانیم محتوایی را به شما پیشنهاد بدهیم که متناسب با علاقه‌ها و ترجیحات شما باشد. بسیاری از مرورگرها امکان غیرفعال کردن کوکی را فراهم کرده‌اند.

 
۲-۴- اطلاعاتی که بعد از ایجاد حساب کاربری در اختیار آهیل قرار می‌گیرد

اطلاعاتی که توسط آهیل (بعد از ایجاد حساب کاربری) جمع‌آوری می‌شوند شامل موارد ذیل است:

۱-۲-۴- اطلاعاتی که برای ایجاد حساب کاربری در نرم‌افزار آهیل ضروری است شامل شماره تلفن همراه، نام کاربری یا سایر اطلاعاتی که شما در اختیار آهیل قرار می‌دهید،

۲-۲-۴- فهرستی از محصولات خریداری شده (مانند برنامه, بخش, مطلب و ...)،

۳-۲-۴- سوابق کلیه خریدها در بستر آهیل.

۳-۴- صدا و مکاتبات شما در تماس با تیم پشتیبانی ضبط می‌گردد.

**در صورتی که شما مایل نیستید اطلاعات شما در اختیار آهیل قرار گیرد، لطفا از نصب نرم‌افزار آهیل و یا ایجاد حساب کاربری و ثبت اطلاعات شخصی در نرم‌افزار آهیل خودداری نمایید.**

## ۵- آهیل از اطلاعات چه استفاده‌ای می کند
موارد عمده استفاده از اطلاعات عبارتند از:

۱-۵- استفاده از اطلاعات به منظور اجرای قرارداد فعلی یا آتی بین آهیل و کاربر یا در مواردی که برای استیفای حقوق قانونی آهیل ضروری باشد. به عبارت دیگر، از آنجا که آهیل برای ارائه بهترین محصولات و خدمات، با بیشترین امنیت برای کاربر و همچنین بهبود خدمات نیاز به استفاده از برخی اطلاعات دارد، بنابراین آهیل با استفاده از اطلاعات کاربران ممکن است اقدامات ذیل را انجام دهد:

۱-۱-۵- ارزیابی عملکرد نرم‌افزار آهیل و رفع اشکالات آن‌ها در نسخه‌های آتی،

۲-۱-۵- افزایش امنیت و صحت عملکرد سایت و نرم‌افزار،

۳-۱-۵- بهبود تجربۀ کاربری از طریق انطباق نرم‌افزار آهیل با نیازها و شرایط کاربر و سیستم‌عامل‌های مورد استفاده در دستگاه‌های متنوع کاربران،

۴-۱-۵- تحلیل رفتار کاربران در استفاده از سایت و نرم‌افزار از جمله در مواجهه با نتایج جستجو و در نتیجه بهبود نتایج جست‌وجو با توجه به کلیدواژه‌های جستجو شده در میان کاربران،  

۵-۱-۵- ارائه خدمات به نحوی که کاربر بتواند به نحوی کارآمد و منحصر به فرد، از کلیه امکانات موجود در برنامه استفاده کند به عنوان مثال بهبود نتایج جستجو و ارائه پیشنهاد‌های اختصاصی به کاربر،

۶-۱-۵- آموزش تیم پشتیبانی برای پاسخگویی به کاربران و نظارت بر عملکرد آن‌ها،

۷-۱-۵- استفاده از اطلاعات برای طرح دعوا توسط آهیل، دفاع و پاسخگویی در برابر دعاوی مطروحه علیه آهیل و هرگونه اقدام قضایی یا اداری مرتبط به منظور دفاع از حقوق و اموال آهیل یا کاربران،

۸-۱-۵-  حسب مورد استفاده از اطلاعات برای بازپرداخت وجوه به کاربران،

۹-۱-۵- انجام مکاتبات و تماس با کاربران توسط تیم پشتیبانی،

۱۰-۱-۵- توسعه و ارائه خدمات بهتر و بیشتر توسط آهیل یا مجموعه شرکت‌های همکار و وابسته به آهیل،

۵-۲- آهیل اطلاعات کاربران را برای ارائه‌ی گزارش‌های آماری از صنعت و کاربران، بدون اینکه به طور مستقیم به یک شخص حقیقی مشخص و معین مرتبط باشد، استفاده می‌کند.

## ۶- اطلاعات در اختیار چه اشخاصی قرار می گیرند
۱-۶- آهیل ممکن است در راستای مطابقت عملکردش با قوانین و مقررات کشور در حال فعالیت, اطلاعات موضوع این سند را در جریان رسیدگی قضایی ویا در پاسخ به دستور مراجع قضایی ذی‌صلاح در اختیار نهادهای ذی‌ربط قرار دهد.

۲-۶- آهیل به اشخاص ثالثی که به نحوی در ارائه خدمات با ما همکاری می‌کنند و یا وابسته به آهیل هستند، تنها در چارچوب این سند اجازه استفاده و پردازش اطلاعات شخصی شما را می‌دهد.

## ۷-  امنیت اطلاعات شخصی
۱-۷- یکی از اولویت‌های اصلی آهیل محافظت از اطلاعات حساب کاربران و جلوگیری از دسترسی‌های غیرمجاز به این اطلاعات است. بر همین اساس:

۱-۱-۷- بسیاری از خدمات آهیل با SSL‌ رمزگذاری شده‌اند،

۲-۱-۷- برای هر بار ورود به حساب کاربری در آهیل از رمز عبور یک‌بار مصرف (OTP) استفاده می‌شود که تنها با دسترسی به شماره تلفن همراهی که از طریق آن در آهیل، حساب کاربری خود را ایجاد کرده‌اید امکان‌پذیر است،

۳-۱-۷- اطلاعات حساب یا کارت بانکی که در زمان پرداخت وارد می‌کنید، در درگاه بانکی وارد می‌شوند و به هیچ‌ عنوان در آهیل دریافت و ذخیره نخواهند شد و از طریق درگاه بانکی مورد استفاده خواهند بود.

۲-۷- علی‌رغم تمام رویه‌های ایمنی که آهیل مطابق با قانون به هنگام ارائه خدمات اتخاذ کرده است، متاسفانه تدابیر امنیتی را نمی‌توان به صورت صد در صدی تضمین نمود، بنابراین مقتضی است:

۱-۲-۷- از اطلاعات حساب کاربری خود محافظت کرده و آن‌ها را در اختیار اشخاص ثالث قرار ندهید،

۲-۲-۷- رمز عبوری را انتخاب نمایید که حتی‌الامکان برای دیگران غیر قابل حدس باشد،

۳-۲-۷- در صورت وقوع سرقت گوشی همراه و همچنین پیش از واگذاری آدرس ایمیل و شماره تلفنی که با آن حساب کاربری ایجاد کرده‌اید، موضوع را به آهیل اطلاع دهید تا حساب کاربری شما تعلیق شده یا اطلاعات موجود در آن تغییر کند. در غیر این صورت و در موارد دسترسی اشخاص ثالث به رمز عبور شما، تمامی مسئولیت هرگونه استفاده یا سوءاستفاده از حساب کاربری شما به عهدۀ شخص شماست و آهیل هیچ‌گونه مسئولیتی در این مورد ندارد.

## ۸- درخواست های شما
تحت شرایطی، شما می توانید متقاضی هر یک از موارد ذیل در رابطه با اطلاعات شخصی خود باشید:

۱-۸- درخواست دسترسی به اطلاعات شخصی خود که در اختیار آهیل قرار دارد،

۲-۸- درخواست تکمیل اطلاعات ناقص یا اصلاح اطلاعات نادرستی که در اختیار آهیل قرار دارد،

۳-۸- درخواست حذف یا محو کردن اطلاعات شخصی؛ در این خصوص آهیل درخواست شما را بررسی و تنها در چارچوبی که قانون اجازه می‌دهد اطلاعات را حذف یا محو می‌نماید و به نحو مقتضی به شما اطلاع‌رسانی خواهد کرد،

۴-۸- اعلام عدم رضایت نسبت به جمع‌آوری، ذخیره، پردازش و توزیع اطلاعات شخصی در مواردی که به موجب قانون این اقدامات مستلزم رضایت شماست؛ در این خصوص آهیل درخواست شما را بررسی و تنها در چارچوبی که قانون اجازه می‌دهد اقدام و به نحو مقتضی به شما اطلاع‌رسانی خواهد کرد. همانطور که قبلا ذکر شد، عدم دسترسی آهیل به برخی اطلاعات، ممکن است مانع ارائه تمام یا برخی از خدمات یا عملکرد مناسب برنامه گردد.

## ۹- شرایط درخواست:
۱-۹- شما می توانید درخواست های خود را به نشانی الکترونیکی ahil.app.sup@gmail.com ارسال نمایید.

۲-۹- درخواست شما در هیچ یک از موارد فوق متضمن پرداخت هزینه نمی‌باشد.

۳-۹- در هر یک از موارد فوق، آهیل ممکن است اطلاعاتی را به منظور تایید هویت و حصول اطمینان از حق دسترسی شما به اطلاعات شخصی، درخواست کند. این اقدامات و تدابیر با هدف محافظت از اطلاعات و جلوگیری از دسترسی‌های غیرمجاز به اطلاعات شخصی شما انجام می‌شوند.

۴-۹- آهیل هر درخواست را ظرف حداکثر یک ماه پاسخ خواهد داد مگر آنکه پیچیدگی یا تعدد موضوعات بررسی طولانی‌تری را اقتضا کند؛ در این صورت آهیل، اطلاع‌رسانی های لازم را انجام خواهد داد.
`

const englishMarkdown = `# Privacy Policy
**Effective Date: January 21, 2024**

"Ahil" respects the privacy of its users and is committed to protecting the personal information you provide. Since collecting and processing personal information is an inevitable part of mobile and internet-based processes, it is essential to read this document titled "Privacy Policy" and any other messages sent to your account regarding the collection and processing of information by Ahil.

This document includes the following sections:

    1. About Ahil
    2. Changes to this Document
    3. Third-Party Apps, Sites, and Services
    4. What Information is Collected by Ahil
    5. How Ahil Uses Information
    6. Who Has Access to Information
    7. Personal Information Security
    8. Your Requests
    9. Request Conditions

## 1. About Ahil
Ahil is the first intelligent planning platform based on social networking where users can present, sell, and purchase plans, training, and products.

In this document, "Ahil" and "we" refer to Rahpouyan Arman Negaresh Novin Exon Company, registration number 20918.

## 2. Changes to this Document
This document has been drafted in accordance with the latest changes in country laws and regulations and outlines all your rights under the E-Commerce Law of 2003 and relevant international documents.

This document may be subject to changes and revisions, and if notification of changes is legally required, users will be informed. This document was last reviewed and updated on January 21, 2024.

## 3. Third-Party Apps, Sites, and Services
The Ahil software contains third-party links that may lead to the collection of your personal information when clicked. Ahil recommends that in addition to this document and its changes, you carefully read the Privacy Policies of third-party links. Ahil takes no responsibility for information you share with third parties. This also applies to third-party content you see on the site and their suggestions regarding the use of their products and services.

## 4. What Information is Collected by Ahil
Information may become available to Ahil through your installation and use of Ahil services (technical information and server reports are mainly collected this way and stored on our servers), and Ahil may also receive information directly from you (when creating an account, contacting support, or completing any form or optional information entry).

### 4.1. Information Collected Through Installation and Use of Ahil Software

Information about the use of Ahil services and the device on which Ahil software is installed is collected simultaneously with the software installation on your device (without creating an account). Some of this information includes:

4.1.1. Device type, device operating system type
4.1.2. Your device's Android ID and Android advertising ID

> The Android advertising ID is used solely for user behavior analysis and displaying personalized advertisements or suggestions, without being directly linked to a specific individual. If the user changes the advertising ID, the new advertising ID will not be connected to the previous advertising ID and its related information.

4.1.3. Searches performed and results selected
4.1.4. Technical information and important device information during crashes including total RAM and its used space during crash, crash type
4.1.5. We may use cookies in collecting information. A cookie is a file created by the browser at a website's request and allows the site to store your visits and customize them. For example, we can use cookies to suggest content that matches your interests and preferences. Many browsers provide the option to disable cookies.

### 4.2. Information Provided After Creating an Account

Information collected by Ahil (after creating an account) includes:

4.2.1. Information necessary for creating an account in Ahil software including mobile phone number, username, or other information you provide to Ahil
4.2.2. List of purchased products (such as plans, sections, content, etc.)
4.2.3. Records of all purchases made through Ahil

4.3. Your voice and correspondence with the support team are recorded.

**If you do not want your information to be available to Ahil, please refrain from installing Ahil software or creating an account and registering personal information in Ahil software.**

## 5. How Ahil Uses Information
Major uses of information include:

### 5.1. Use of information for:

5.1.1. Evaluating Ahil software performance and fixing issues in future versions
5.1.2. Increasing security and accuracy of site and software operation
5.1.3. Improving user experience by adapting Ahil software to user needs and conditions
5.1.4. Analyzing user behavior in using the site and software
5.1.5. Providing services so users can efficiently use all available features
5.1.6. Training support team for user response and monitoring their performance
5.1.7. Using information for legal proceedings
5.1.8. Processing refunds to users when applicable
5.1.9. Correspondence and contact with users by support team
5.1.10. Developing and providing better services

5.2. Ahil uses user information to provide statistical reports about the industry and users, without directly linking to specific individuals.

## 6. Who Has Access to Information
6.1. Ahil may provide information subject to this document to relevant authorities in response to judicial orders from competent judicial authorities.

6.2. Ahil allows third parties who cooperate in providing services or are affiliated with Ahil to use and process your personal information only within the framework of this document.

## 7. Personal Information Security
### 7.1. One of Ahil's main priorities is protecting user account information and preventing unauthorized access. Accordingly:

7.1.1. Many Ahil services are SSL encrypted
7.1.2. One-time password (OTP) is used for each login
7.1.3. Banking information entered during payment is processed through bank portals and never stored by Ahil

7.2. Despite all security measures, security measures cannot be 100% guaranteed, therefore:

7.2.1. Protect your account information and don't share it with third parties
7.2.2. Choose a password that is difficult for others to guess
7.2.3. Report device theft or changes in contact information to Ahil

## 8. Your Requests
Under certain conditions, you may request:

8.1. Access to your personal information held by Ahil
8.2. Completion of incomplete information or correction of incorrect information
8.3. Deletion or removal of personal information
8.4. Withdrawal of consent for collection, storage, processing, and distribution of personal information

## 9. Request Conditions
9.1. You can send your requests to ahil.app.sup@gmail.com
9.2. Your requests do not incur any costs
9.3. Ahil may request information to verify your identity
9.4. Ahil will respond to each request within a maximum of one month unless complexity requires longer review`

const source = (markdown) => markdown.replace(/\n/gi, "&nbsp;\n\n ");

export const Privacy = () => {
    const {theme} = React.useContext(ThemeContext);
    const { i18n } = useTranslation();
    
    const markdown = i18n.language === 'fa' ? persianMarkdown : englishMarkdown;

    return (
        <div className={theme === 'light' ? 'light-rule-container' : 'rule-container'}>
            <Markdown className={theme === 'light' ? 'light-p-rule' : 'p-rule'}>{source(markdown)}</Markdown>
        </div>
    )
}
